var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95911e-05 4.80001C4.95911e-05 4.13729 0.537331 3.60001 1.20005 3.60001H22.8C23.4628 3.60001 24 4.13729 24 4.80001C24 5.46272 23.4628 6.00001 22.8 6.00001H1.20005C0.537331 6.00001 4.95911e-05 5.46268 4.95911e-05 4.80001ZM22.8 10.8H1.20005C0.537331 10.8 4.95911e-05 11.3373 4.95911e-05 12C4.95911e-05 12.6627 0.537331 13.2 1.20005 13.2H22.8C23.4628 13.2 24 12.6627 24 12C24 11.3373 23.4628 10.8 22.8 10.8ZM22.8 18C22.8 18 1.86267 18 1.2 18C0.537328 18 0 18.5373 0 19.2C0 19.8627 0.537328 20.4 1.2 20.4C1.86267 20.4 22.8 20.4 22.8 20.4C23.4628 20.4 24 19.8627 24 19.2C24 18.5373 23.4628 18 22.8 18Z",
    fill: "#202047"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuIcon);
export default __webpack_public_path__ + "static/media/burgerMenuIcon.9c72a7057a7f8deb478f8d1f21f948f0.svg";
export { ForwardRef as ReactComponent };